export default __webpack_public_path__ + "static/media/diamond-igi-gia-cer.4eedc99f.png";